import { Component, ViewEncapsulation, Input } from '@angular/core';
import { VcaAlert } from './vca-alert';
import { VcaAlertsService } from './vca-alerts.service';
import { Alert } from '@clr/angular';


@Component({
    selector: 'vca-alerts',
    encapsulation: ViewEncapsulation.None,
    styles: [require('./vca-alerts.scss')],
    template: `
    <div class="vca-alerts-module">
        <div class="vca-alerts" [class.vca-alerts-overlay]="alertOverlay">
        <clr-alert 
            [clrAlertType]="'alert-' + alert.type"
            [clrAlertSizeSmall]="alertSizeSmall"
            [clrAlertAppLevel]="alertAppLevel"
            [clrAlertClosable]="alertClosable"
            (clrAlertClosedChange)="onAlertClosed(alert)"
            *ngFor="let alert of alerts">
            <div class="alert-item" *ngFor="let msg of alert.message">
                <span class="alert-text">{{msg}}</span>
            </div>
        </clr-alert>
        </div>     
    </div>     
    `
})

export class VcaAlerts {
    @Input() alertClosable: boolean = true;
    @Input() alertSizeSmall: boolean = false;
    @Input() alertAppLevel: boolean = false;
    @Input() timeout: number = 3000;
    @Input() location: string = 'main';
    @Input() alertOverlay: boolean = false;
    @Input() disableTimeout: boolean = false; // For alerts to be persistent
    private alerts: VcaAlert[];

    constructor(private alertsService: VcaAlertsService) {
        this.alerts = new Array<VcaAlert>();

        this.alertsService.alerts.subscribe(alert => {
            if ((alert.location === this.location) && !this.checkIfPresent(alert))  {
                this.alerts.push(alert);
                if (!this.disableTimeout) {
                    setTimeout(() => { this.hide.bind(this)(alert); }, alert.timeout || this.timeout);
                }
            }
        });
    }

    onAlertClosed(alert: VcaAlert) {
        this.hide.bind(this)(alert);
    }

    private hide(alert: VcaAlert) {
        let index = this.alerts.indexOf(alert);
        if (index >= 0) {
            this.alerts.splice(index, 1);
        }
    }

    private checkIfPresent(alert: VcaAlert) {
        return this.alerts.find((alrt) => { return this.compareArrayIfEqual(alrt.message, alert.message); });
    }

    private compareArrayIfEqual(arr1, arr2) {
        arr1.forEach(errMsg => {
            if (arr2.indexOf(errMsg) === -1) {
                return false;
            }
        });
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/common/vca-alerts/vca-alerts.ts